
  import React from 'react'
  import { MDXTag } from '@mdx-js/tag'
  

const layoutProps = {
  
};
export default class MDXContent extends React.Component {
  constructor(props) {
    super(props)
    this.layout = null
  }
  render() {
    const { components, ...props } = this.props

    return <MDXTag
             name="wrapper"
             
             components={components}><div className='title'>Hinweise an die Redaktion</div>
<MDXTag name="p" components={components}>{`Leben Sie in einem Gefahrengebiet? Wissen Sie von stark gefährdeten sensiblen Objekten? Ihren Hinweis nimmt das `}<a href="mailto:recherchedesk@tamedia.ch">{`Tamedia Recherchedesk`}</a>{` gerne entgegen.`}</MDXTag>
           </MDXTag>
  }
}
MDXContent.isMDXComponent = true
  